const translations = {
  "en": {
    "Get more personalized analysis of stocks or cryptocurrencies.": "Get more personalized analysis of stocks or cryptocurrencies.",
    "Login / Sign up to Edgen": "Login / Sign up to Ed",
    "Login failed, please try again.": "Login failed, please try again."
  },
  "zh-tw": {
    "Get more personalized analysis of stocks or cryptocurrencies.": "獲得更多針對股票或加密貨幣的個人化分析。",
    "Login / Sign up to Edgen": "登入 / 註冊 Ed 帳號",
    "Login failed, please try again.": "登入失敗，請重試。"
  }
};

export default translations;
